import { hasPermission } from "@/lib/utils";
import { useAuthStore } from "@/providers/auth-store-provider";
import { AuthResult } from "@/utils/auth";
import { AppPermission, UserRole } from "@/utils/types";

export function useServerPermissions(auth: AuthResult) {
  return (...permissions: AppPermission[]) => {
    return hasPermission(auth.token.user_roles as UserRole[], ...permissions);
  }
}

export function useClientPermissions() {
  const roles = useAuthStore((state) => state.roles);

  return (...permissions: AppPermission[]) => {
    return hasPermission(roles, ...permissions);
  }
}